import { FC } from "react"
import {
  GameProgressChestImg,
  GameProgressGroundImg,
  Ton3dIcon
} from "@/assets"
import { useGame } from "@/providers/GameProvider"
import styles from "./GameTopProgress.module.scss"
import { getTunnelWidth } from "./helpers"
import { ProgressTunnel } from "./ui/ProgressTunnel"

export const GameTopProgress: FC = () => {
  const { matchSession, player, opponent, isTonMatch } = useGame()

  const playerProgress = player?.progress ?? 0
  const opponentProgress = opponent?.progress ?? 0

  return (
    <div className={styles.GameTopProgress}>
      <div
        className={styles.GameTopProgress_bg}
        style={{ backgroundImage: `url(${GameProgressGroundImg})` }}
      />
      <div className={styles.GameTopProgress_content}>
        <ProgressTunnel
          progress={playerProgress}
          freezingMovements={player?.freezingMovements ?? 0}
          block={player?.block ?? 0}
          side="player"
          tunnelWidth={getTunnelWidth(playerProgress)}
        />
        <div className={styles.GameTopProgress_content_chest}>
          {isTonMatch && (
            <div className={styles.GameTopProgress_content_chest_reward}>
              <Ton3dIcon /> {matchSession?.pot?.prizeValue}
            </div>
          )}
          <img src={GameProgressChestImg} alt="chest" />
        </div>
        <ProgressTunnel
          progress={opponentProgress}
          freezingMovements={opponent?.freezingMovements ?? 0}
          block={opponent?.block ?? 0}
          side="opponent"
          tunnelWidth={getTunnelWidth(opponentProgress)}
        />
      </div>
    </div>
  )
}
